module.exports = __webpack_public_path__ + "static/media/logo_docset.71b8ff54.png";